import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { format } from 'date-fns';
import { he } from 'date-fns/locale';
import { numberToHebrewLetter } from '../../../../../utils/hebrew-date-utils';
import globalUserPage from '../../../../../stores/global-user-page';
import {
  ExamMetadata,
  SessionType,
} from '../../../../../api/types/programs/course/exams/response/exam-metadata';

// Helper interface for flattened exam session data for table display
interface ExamSessionForDisplay {
  examId: number;
  examName: string;
  courseId: number;
  sessionId: number;
  sessionDate?: Date;
  sessionType: SessionType;
  gradesApproval: boolean;
  // Hardcoded program info - to be replaced later

  courseName: string;
  programName: string;
  programStartYear: number;
  programNumberInYear: number;
  programBranch: string;
}

// Helper function to flatten exam sessions for table display
const flattenExamSessions = (
  exams: ExamMetadata[],
): ExamSessionForDisplay[] => {
  return exams.flatMap((exam) =>
    exam.sessions
      .filter((session) => !session.gradesApproval) // Only show sessions where grades are not yet approved
      .map((session) => ({
        examId: exam.id,
        examName: exam.examName,
        courseId: exam.courseId,
        sessionId: session.id,
        sessionDate: session.sessionDate,
        sessionType: session.sessionType,
        gradesApproval: session.gradesApproval,
        // Hardcoded program info - to be replaced later
        courseName: exam.courseName,
        programName: exam.programName,
        programStartYear: exam.programStartYear,
        programNumberInYear: exam.annualSerialNumber,
        programBranch: 'קמפוס ראשי',
      })),
  );
};

export const UserPageLecturerExams = () => {
  // Flatten exam sessions for display
  const flattenedExamSessions = flattenExamSessions(
    globalUserPage.lecturerDetails?.exams || [],
  );

  /*  if (loading) {
    return (
      <div
        className="flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <ProgressSpinner />
      </div>
    );
  }*/

  return (
    <div className="p-4" style={{ width: '100%', maxWidth: '100%' }}>
      <div className="grid">
        <div className="col-12">
          <h2 className="mb-3">בחינות שטרם אושררו בהם ציונים</h2>
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <DataTable
              value={flattenedExamSessions}
              rows={10}
              emptyMessage={
                <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
              }
              className="p-datatable-striped"
              style={{ width: '100%', minWidth: '100%' }}
              scrollable
              scrollHeight="flex"
              resizableColumns
              columnResizeMode="expand"
            >
              <Column
                field="examName"
                header="שם הבחינה"
                style={{ width: '15%', textAlign: 'right' }}
              />
              <Column
                field="courseName"
                header="קורס"
                style={{ width: '15%', textAlign: 'right' }}
              />
              <Column
                field="programName"
                header="תוכנית"
                style={{ width: '15%', textAlign: 'right' }}
              />
              <Column
                field="programStartYear"
                header="שנת התחלה"
                style={{ width: '10%', textAlign: 'right' }}
                body={(rowData: ExamSessionForDisplay) =>
                  rowData.programStartYear
                }
              />
              <Column
                field="programNumberInYear"
                header="מספר תוכנית בשנה"
                style={{ width: '10%', textAlign: 'right' }}
                body={(rowData: ExamSessionForDisplay) =>
                  rowData.programNumberInYear
                }
              />
              {/*              <Column
                field="sessionType"
                header="מועד"
                style={{ width: '10%', textAlign: 'right' }}
                body={(rowData: ExamSessionForDisplay) => {
                  const sessionNumber =
                    rowData.sessionType === SessionType.FIRST_SESSION
                      ? 1
                      : rowData.sessionType === SessionType.SECOND_SESSION
                        ? 2
                        : 3;
                  return `מועד ${numberToHebrewLetter(sessionNumber)}׳`;
                }}
              />*/}
              <Column
                field="sessionDate"
                header="תאריך"
                style={{ width: '10%', textAlign: 'right' }}
                body={(rowData: ExamSessionForDisplay) =>
                  rowData.sessionDate
                    ? format(new Date(rowData.sessionDate), 'dd/MM/yyyy', {
                        locale: he,
                      })
                    : 'טרם נקבע תאריך'
                }
              />
              {/*              <Column
                header="פעולות"
                style={{ width: '15%', textAlign: 'right' }}
                body={(rowData: ExamSessionForDisplay) => (
                  <Button
                    label="הזן ציונים"
                    icon="pi pi-pencil"
                    className="p-button-sm p-button-outlined"
                    onClick={() => {
                      // Handle grade input
                      console.log(
                        'Enter grades for exam:',
                        rowData.examId,
                        'session:',
                        rowData.sessionId,
                      );
                    }}
                  />
                )}
              />*/}
            </DataTable>
          </div>
        </div>
      </div>

      <style>
        {`
          .p-datatable .p-datatable-thead > tr > th {
            background-color: var(--surface-section);
            color: var(--surface-900);
            font-weight: 600;
          }
          .p-datatable .p-datatable-tbody > tr {
            background-color: var(--surface-ground);
          }
          .p-datatable .p-datatable-tbody > tr:nth-child(even) {
            background-color: var(--surface-hover);
          }
          .p-datatable-wrapper {
            margin-right: 0 !important;
            margin-left: 0 !important;
          }
        `}
      </style>
    </div>
  );
};
